import Highcharts from 'highcharts';
import Accessibility from 'highcharts/modules/accessibility';
import AnnotationsModule from 'highcharts/modules/annotations';

import 'leaflet/dist/leaflet.css';
import './styles/index.css';

import { Routes } from './routes';

Accessibility(Highcharts);
AnnotationsModule(Highcharts);

export function App() {
  return <Routes />;
}
